import { createApi } from '@reduxjs/toolkit/query/react';
import { MicrosoftUser } from './types/get-microsoft-user';
import getMicrosoftGraphAccessToken from '@/features/Auth/utils/get-microsoft-graph-access-token';
import createAuthenticatedBaseQuery from '@/app/services/utils/create-authenticated-base-query';

const baseQuery = createAuthenticatedBaseQuery({
  baseUrl: '',
  getAccessToken: getMicrosoftGraphAccessToken,
});

export const microsoftApi = createApi({
  reducerPath: 'microsoftApi',
  baseQuery,
  endpoints: (build) => ({
    getMicrosoftUser: build.query<MicrosoftUser, undefined>({
      query: () => ({ url: 'https://graph.microsoft.com/v1.0/me' }),
    }),
  }),
});

export const { useGetMicrosoftUserQuery } = microsoftApi;
